export default class BrandingColorsModel {
  public primaryColor: string = null;
  public secondaryColor: string = null;
  public contentColor: string = null;
  public backgroundColor: string = null;
  public borderColor: string = null;
  public additionalColor: string = null;
}
